(function() {
  'use strict';
  angular.module('common')
  .directive('dnDatePicker', ['uibDateParser',function(uibDateParser) {
     return {
       restrict: 'E',
       require: 'ngModel',
       scope: {
         ngModel: '=',
         format: '@',
         id: "@",
         isRequired: "=?",
         autoFocus: '=?',
         minDate: '=?',
         maxDate: '=?',
         onChange: '&?'
       },
       templateUrl : '/js/common/datePicker.html',
       link: function ($scope, element, attrs, ngModelController) {
         $scope.isOpened=false;
         $scope.autoFocus = $scope.autoFocus ? $scope.autoFocus : false;
         $scope.dateOptions = {showWeeks: false};
         if ($scope.minDate) {
           $scope.dateOptions.minDate = $scope.minDate;
         }
         if ($scope.maxDate) {
           $scope.dateOptions.maxDate = $scope.maxDate;
         }
         $scope.togglePopup = function() {
             if ($scope.ngModel &&  typeof $scope.ngModel == "string") {
               $scope.picked = uibDateParser.parse($scope.ngModel,$scope.format);
             } else if ($scope.ngModel === undefined) {
                $scope.picked = undefined;
             }
              $scope.isOpened=!$scope.isOpened;
          };
         $scope.$watch('picked',function(n,o) {
           if (!$scope.isOpened && $scope.picked && typeof $scope.picked == "object") {
              $scope.ngModel = uibDateParser.filter($scope.picked, $scope.format);
              $scope.handleChange();
           }
         });
         $scope.handleChange = function() {
           if ($scope.onChange) {
             $scope.onChange();
           }
         };
       }
     };
   }]);
})();
